/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { InvoiceTransactionStatus } from './InvoiceTransactionStatus';
// @ts-ignore
import {
// @ts-ignore
    InvoiceTransactionStatusFromJSON,
// @ts-ignore
    InvoiceTransactionStatusFromJSONTyped,
// @ts-ignore
    InvoiceTransactionStatusToJSON,
} from './InvoiceTransactionStatus';

/**
 * 
 * @export
 * @interface InvoiceTransaction
 */
export interface InvoiceTransaction {
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    invoiceId: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    paymentMethodId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    provider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    providerCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    providerPaymentIntentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    providerChargeId?: string | null;
    /**
     * 
     * @type {InvoiceTransactionStatus}
     * @memberof InvoiceTransaction
     */
    status: InvoiceTransactionStatus;
    /**
     * 
     * @type {Amount}
     * @memberof InvoiceTransaction
     */
    amount: Amount;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    failureCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceTransaction
     */
    failureMessage?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceTransaction
     */
    attemptedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceTransaction
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceTransaction
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the InvoiceTransaction interface.
 */
// @ts-ignore
export function instanceOfInvoiceTransaction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "invoiceId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "attemptedAt" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function InvoiceTransactionFromJSON(json: any): InvoiceTransaction {
    return InvoiceTransactionFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceTransaction {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'invoiceId': json['invoice_id'],
        'paymentMethodId': !exists(json, 'payment_method_id') ? undefined : json['payment_method_id'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'providerCustomerId': !exists(json, 'provider_customer_id') ? undefined : json['provider_customer_id'],
        'providerPaymentIntentId': !exists(json, 'provider_payment_intent_id') ? undefined : json['provider_payment_intent_id'],
        'providerChargeId': !exists(json, 'provider_charge_id') ? undefined : json['provider_charge_id'],
        'status': InvoiceTransactionStatusFromJSON(json['status']),
        'amount': AmountFromJSON(json['amount']),
        'failureCode': !exists(json, 'failure_code') ? undefined : json['failure_code'],
        'failureMessage': !exists(json, 'failure_message') ? undefined : json['failure_message'],
        'attemptedAt': (new Date(json['attempted_at'])),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

// @ts-ignore
export function InvoiceTransactionToJSON(value?: InvoiceTransaction | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'invoice_id': value.invoiceId,
        'payment_method_id': value.paymentMethodId,
        'provider': value.provider,
        'provider_customer_id': value.providerCustomerId,
        'provider_payment_intent_id': value.providerPaymentIntentId,
        'provider_charge_id': value.providerChargeId,
        'status': InvoiceTransactionStatusToJSON(value.status),
        'amount': AmountToJSON(value.amount),
        'failure_code': value.failureCode,
        'failure_message': value.failureMessage,
        'attempted_at': (value.attemptedAt.toISOString()),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

